import { useCustomCreateWorksheetProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useCreateWorksheetProduct() {
  const [mutation, { loading, data, error }] = useCustomCreateWorksheetProductMutation({
    refetchQueries: ["customGetWorksheetProducts", "GetWorksheetProducts"],
  });
  const [createWorksheetProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createWorksheetProduct",
    },
    {
      successMessage: getLocalString("worksheet.create-product-success"),
      failureMessage: getLocalString("worksheet.create-product-failure"),
      showValidationErrors: true,
    }
  );

  return [createWorksheetProduct, context] as const;
}
